import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ITablePagination, MouldLogEntry } from 'src/app/models/domain';
import { MouldLogDataService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { ErrorState } from './error-state';
import { IPage } from './paged-collection';

@Injectable({ providedIn: 'root' })
export class MouldLogService {
  private readonly state = new ErrorState();

  public readonly error$ = this.state.error$;

  public constructor(private readonly mouldLogDataService: MouldLogDataService) {}

  public clearError() {
    this.state.setError(undefined);
  }

  public loadMouldLog(
    pagination: ITablePagination,
    equipmentNumber: string,
    entryCodes?: string[]
  ): Observable<IPage<MouldLogEntry>> {
    // Starting a load clears the previous error, which CustomEntityStore.setLoading(true)
    // used to do. Without it a transient failure sticks: the template renders the error
    // instead of the table, so a later success would never be seen.
    this.state.setError(undefined);

    return this.mouldLogDataService.loadMouldLogPage(pagination, equipmentNumber, entryCodes).pipe(
      map(({ data, total }): IPage<MouldLogEntry> => ({
        currentPage: pagination.page,
        data,
        lastPage: Math.ceil(total / pagination.perPage),
        perPage: pagination.perPage,
        total,
      })),
      catchError((error) => {
        handleError(this.state, error);

        // EMPTY, not NEVER: PagedCollection's finalize() has to run to clear the
        // spinner. Akita got this implicitly, because its setError also called
        // set([]), which cleared loading.
        return EMPTY;
      })
    );
  }
}
